export const INITIAL_PERMISSIONS_SEARCH_PARAMS = {
  page: 1,
  id: '',
  name: '',
  internal: '',
  external: '',
  sort_method: 'desc',
  order_by: 'id',
}

export const INITIAL_PERMISSION = {
  id: null,
  name: '',
  parent_id: null,
  internal: 0,
  external: 0,
}

export const PERMISSIONS_TYPE = {
  INTERNAL: 1,
  EXTERNAL: 2,
}
